 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MaintenanceStatusState } from '../../actions/types/schedule-maintenance/PostMaintenanceStatusTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: MaintenanceStatusState = {
  isLoading: true,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  savesuccess: false,
  errorStatusMessage: '',
  MaintenanceStatusDetails: []
};

/**
 * get metric summary Slice to get metric
 */
export const getMaintenanceStatusSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getMaintenanceStatusStarted: (state) => {
      state.isLoading = true;
    },

    getMaintenanceStatusSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.savesuccess = true;
      state.errorStatusMessage = '';
      state.MaintenanceStatusDetails = action.payload;
    },

    getMaintenanceStatusFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.savesuccess = false;
      state.errorStatusMessage = action.payload;
      state.MaintenanceStatusDetails = initialState.MaintenanceStatusDetails;
    },

    clearMaintenanceStatus: (state) => {
      state.isLoading = false;
      state.savesuccess = false;
      state.errorStatusMessage = '';
      state.MaintenanceStatusDetails = initialState.MaintenanceStatusDetails;
    }
  }
});

export const {
  getMaintenanceStatusStarted,
  getMaintenanceStatusSuccess,
  getMaintenanceStatusFail,
  clearMaintenanceStatus
} = getMaintenanceStatusSlice.actions;
export default getMaintenanceStatusSlice.reducer;
